





import Vue from 'vue'
import { PropValidator } from 'vue/types/options'  // using "as () => T" seems enough
import { IDevice } from '@/types/model'
import { setInterval } from 'timers'
import { thumb_size_t } from '@/store/modules/pref'
import { reqMan } from '@/singleton'
import { convertToDataUrl } from '@/utils'
import { point_t } from '@/vw_algorithm'


interface geometry_size_t {
  width: number
  height: number
}

export default Vue.extend({
  model: {
    prop: 'device'
  },
  props: {
    device: {
      type: Object as () => IDevice | null
    },
    thumbSize: {
      type: String,
      default: 'md'
    } as PropValidator<thumb_size_t>,
    /**
     * width and height has higher priority than thumbSize.
     * Don't specify width and height simultaneously.
     */
    width: {
      type: Number,
      default: 0
    },
    /**
     *  width and height has higher priority than thumbSize
     * Don't specify width and height simultaneously.
     */
    height: {
      type: Number,
      defualt: 0
    },
    maxWidth: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    imgDataUrl: '#',
    intervalId: -1,
  }),
  computed: {
    rootSize (): geometry_size_t {
      if (this.width) {
        return { width: this.width, height: this.width * 5 / 9 }
      } else if (this.height) {
        return { width: this.height * 9 / 5, height: this.height }
      } else {
        let w = 0
        switch (this.thumbSize) {
          case 'xs': w = 60; break
          case 'sm': w = 90; break
          case 'md': w = 110; break
          case 'lg': w = 150; break
          case 'xl': w = 200; break
        }
        while (this.$state.common.windowSize.width - w < 200) {
          w -= 2
        }
        if (this.maxWidth >= 1 && w > this.maxWidth) {
          w = this.maxWidth
        }
        return { width: w, height: w * 5 / 9 }
      }
    },
    rootStyle (): string {
      return `width:${this.rootSize.width}px;height:${this.rootSize.height}px;`
    },
    screenStyle (): string {
      // const w = this.
      if (this.device && this.device.vendor === 'Aspeed' && this.device.online) {
        if (this.device.deviceType === 'RX' && this.device.rxInfo.activeState.which === 'vw') {
          const a = this.device.rxInfo.vwTxWindow
          const p0: point_t = {x: a.x1, y: a.y1}
          const p1: point_t = {x: a.x2, y: a.y2}
          // (w, h)
          // range: 0.0 - 1.0
          const wPercOnTx = (p1.x - p0.x) / 10000
          const hPercOnTx = (p1.y - p0.y) / 10000
          const bgSize: geometry_size_t = {
            width: this.rootSize.width / wPercOnTx,
            height: this.rootSize.height / hPercOnTx
          }
          // (x, y)
          // range: 0.0 - 1.0
          const xShiftUnit = p0.x / (p1.x - p0.x)
          const yShiftUnit = p0.y / (p1.y - p0.y)
          const bgPos: point_t = {
            x: -this.rootSize.width * xShiftUnit,
            y: -this.rootSize.height * yShiftUnit
          }
          return `background-image: url(${this.imgDataUrl});` +
          `background-size: ${bgSize.width}px ${bgSize.height}px;` +
          `background-position: left ${bgPos.x}px top ${bgPos.y}px;`
        } else {
          return `background-image: url(${this.imgDataUrl}); background-size: ${this.rootSize.width}px ${this.rootSize.height}px;`
        }
      }
      return ''
    }
  },
  methods: {
    refreshImage () {
      if (!this.device) {return}
      if (this.device.vendor === 'Aspeed' && this.device.online) {
        if (!this.device.rxInfo.tvDetected && !this.device.txInfo.sourceDetected) {
          // if no signal, remove url
          const oldUrl = this.imgDataUrl
          this.imgDataUrl = ''
          URL.revokeObjectURL(oldUrl)
          return
        }
        const url = `/screenshot/${this.device.mac.replace(/:/g, '')}.bmp?nonsense=${Date.now()}`
        reqMan.get(url, { responseType: 'arraybuffer' }).then((raw) => {
          const blob = new Blob([raw])
          const newUrl = URL.createObjectURL(blob)
          const oldUrl = this.imgDataUrl
          this.imgDataUrl = newUrl
          URL.revokeObjectURL(oldUrl)
        }).catch((err) => {
          console.warn('[PreviewScreen] fetch failed')
          // skip
        })
      }
    }
  },
  mounted () {
    if (this.width > 0 && this.height > 0) { console.error(`[To Developer] Don't specify width and width simutaneously`) }
    this.refreshImage()
    this.intervalId = window.setInterval(this.refreshImage, 4000)
  },
  beforeDestroy () {
    clearInterval(this.intervalId)
  }
})
